import getSpreadsheetCellRuntime from 'components/ScalarSpreadsheet/utilities/getSpreadsheetCellRuntime';
import { TotalsColumnProps } from './TotalsColumn.props';
import { StyledTotalsColumn } from './TotalsColumn.styles';

const TotalsColumn = ({ className = '', data, useDisplayCellRuntime = false }: TotalsColumnProps) => {
  const { cellRenderer, valueViewer } = getSpreadsheetCellRuntime(useDisplayCellRuntime);

  return (
    <StyledTotalsColumn
      data={data}
      className={className}
      cellRenderer={cellRenderer}
      valueViewer={valueViewer}
    />
  );
};

export default TotalsColumn;
